$(document).ready(function(){
  $(".product__accordion.accordion .summary__title").on("click" , function(){
    
    if(this.closest('.product__accordion.accordion').classList.contains("show")){
  
      $('div.accordion__content.rte').slideUp();
      $('div.product__accordion.accordion').removeClass('show');
      
    }
    else{
  
      $('div.accordion__content.rte').slideUp();
      $('div.product__accordion.accordion').removeClass('show');
    
      $(this).next().slideDown();
      $(this).parent().toggleClass("show");
      
    }
    
  });

    
    
  const slider = $(".devLeftImages");
  slider
    .slick({    
      slidesToScroll: 1,
      slidesToShow: 1, 
      arrows: false,
      dots: true,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      draggable: true,
      swipe: true, 
      swipeToSlide: true
    }); 
  
  slider.on('wheel', (function(e) {
    e.preventDefault();
  
    if (e.originalEvent.deltaY < 0) {
      $(this).slick('slickPrev');
    } else {
      $(this).slick('slickNext');
    }
  }));  



const swiper = new Swiper('.swiper-container', {
    // Enable horizontal scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true, // Allows dragging the scrollbar
    },
    mousewheel: {
        invert: false,         // Set to true to invert scroll direction (optional)
    },  
    // Other options
    slidesPerView: 1, // Adjust as needed
    spaceBetween: 10, // Adjust as needed
});




  
      

});